import './app.css';
import Slider from 'react-slick';
import { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Button } from '@material-ui/core';
import parse from 'html-react-parser';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import HorizontalTabs from './HorizontalTabs';
import { Skeleton } from '@material-ui/lab';

const Fade = require('react-reveal/Fade');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#f0f0f0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: 16,
      paddingBottom: 32,
      paddingTop: 100,
      '@media screen and (max-width: 1919px)': {
        minHeight: 'initial',
        padding: '6rem 1rem',
      },
      [theme.breakpoints.up(2550)]: {
        paddingTop: 10,
      },
    },
    divForDetail: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    rowHeight: {
      maxHeight: '10.5em',
      overflow: 'hidden',
      marginBottom: 24,
      '& p': {
        lineHeight: '1.5em',
      },
    },
    wraperBox: {
      width: '100%',
      maxWidth: 800,
      margin: '0 auto',
      [theme.breakpoints.up(2550)]: {
        maxWidth: 1000,
      },
    },
    wrapImgDetail: {
      display: 'flex',
      gap: 40,
      marginTop: 48,
      [theme.breakpoints.up(2550)]: {
        maxWidth: 1000,
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    wrapImgDetailChild: {
      width: 400,
      height: 300,
      [theme.breakpoints.up(2550)]: {
        width: 560,
        height: 400,
      },
    },
    titleMain: {
      marginBottom: 32,
      '@media screen and (min-width: 2560px)': {
        fontSize: 60,
      },
    },
    titleSecondary: {
      fontSize: 28,
    },
    imgDetail: {
      width: 200,
      [theme.breakpoints.up(2550)]: {
        width: 250,
      },
    },
    imgDetailChild: {
      height: 130,
      [theme.breakpoints.up(2550)]: {
        height: 200,
      },
    },
    [theme.breakpoints.down('sm')]: {
      rowHeight: {
        maxHeight: '6em',
      },
      imgDetail: {
        display: 'none',
      },
      wrapImgDetail: {
        marginTop: 24,
      },
      titleMain: {
        fontSize: 28,
        marginBottom: 24,
      },
      titleSecondary: {
        marginTop: 16,
        fontSize: 20,
      },
    },
  })
);

function Fasilitas({ isId }: any) {
  const sliderRef = useRef<any>();
  const classes = useStyles();
  const history = useHistory();
  const [activeState, setActiveState] = useState(0);
  const [loadingState, setLoadingState] = useState(true);
  const [fasilitasState, setFasilitasState] = useState<any>([]);
  const [tabState, setTabState] = useState(0);

  const typeFasilitas = fasilitasState
    .filter(
      (v: any, i: any, a: any) =>
        a.findIndex((t: any) => t.id_type === v.id_type) === i
    )
    .map((row: any) => ({
      id: row.id_type,
      title: row.type_title_id,
      title_en: row.type_title_en,
    }));

  const currentSlideData = fasilitasState.filter(
    (row: any) => row.id_type === typeFasilitas[tabState].id
  );

  const settings = {
    className: 'slider variable-width',
    dots: true,
    arrows: false,
    infinite: true,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex: any, newIndex: any) => {
      setActiveState(newIndex);
    },
  };

  const getDataVehicle = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content?type=2`
    );
    const resJson = await res.json();
    const newResJson = resJson.data.rows.map((row: any) => ({
      ...row,
      type_title_id: 'Kendaraan',
      type_title_en: 'Vehicle',
    }));
    const checkType = fasilitasState.some((row: any) => row.id_type === 2);
    if (!checkType) {
      setFasilitasState((prevState: any) => [...prevState, ...newResJson]);
    }
  };

  const getDataSensor = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_URL}/api/jlp/content?type=12`
    );
    const resJson = await res.json();
    const newResJson = resJson.data.rows.map((row: any) => ({
      ...row,
      type_title_id: 'Perlengkapan Operasi',
      type_title_en: 'Equipment',
    }));
    const checkType = fasilitasState.some((row: any) => row.id_type === 12);
    if (!checkType) {
      setFasilitasState((prevState: any) => [...prevState, ...newResJson]);
    }
  };

  const loadData = async () => {
    try {
      await getDataVehicle();
      await getDataSensor();
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  const handleChangeTabs = (event: any, newValue: any) => {
    setActiveState(0);
    setTabState(newValue);
    sliderRef.current?.slickGoTo(0);
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentSlideData.length - 1 === activeState) {
      setTimeout(() => {
        const currentTab =
          tabState >= typeFasilitas.length - 1 ? 0 : tabState + 1;
        handleChangeTabs(null, currentTab);
      }, 4999);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabState, activeState]);

  return (
    <div className={classes.root}>
      {loadingState && (
        <div
          style={{
            width: '100%',
            maxWidth: 1280,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Skeleton
            variant='rect'
            style={{
              height: 42,
              width: '100%',
              maxWidth: 400,
              margin: '0 16px',
              marginBottom: 16,
              textAlign: 'center',
            }}
          />
          <Skeleton
            variant='rect'
            style={{ height: 200, width: '100%', margin: '0 16px' }}
          />
        </div>
      )}
      {!loadingState && (
        <div className={classes.wraperBox}>
          <Typography
            align='center'
            color='primary'
            variant='h4'
            className={classes.titleMain}
          >
            {isId
              ? 'Armada & Perlengkapan Operasi'
              : 'Present Vehicle and Equipment'}
          </Typography>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <HorizontalTabs
              onChangeTab={handleChangeTabs}
              isId={isId}
              listFasilitas={typeFasilitas}
              valueTab={tabState}
            />
          </div>

          {Array.isArray(currentSlideData) && currentSlideData.length ? (
            <div>
              <Fade right>
                <Slider {...settings} ref={sliderRef}>
                  {currentSlideData.map((row: any, i: number) => (
                    <div className={classes.imgDetail}>
                      <div
                        style={{
                          padding: i === activeState ? 0 : 8,
                        }}
                        className={classes.imgDetailChild}
                      >
                        <div style={{ height: '100%' }}>
                          <img
                            src={`${process.env.REACT_APP_URL}/images/${row.image}`}
                            alt={row.title_en}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              marginBottom: 12,
                            }}
                          />
                          <Typography
                            align='center'
                            style={{
                              fontWeight: i === activeState ? 600 : 400,
                              color: i === activeState ? '#e3232a' : '#000',
                            }}
                          >
                            {isId ? row.title_id : row.title_en}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </Fade>
              <Fade left>
                <div className={classes.wrapImgDetail}>
                  <img
                    className={classes.wrapImgDetailChild}
                    src={`${process.env.REACT_APP_URL}/images/${currentSlideData[activeState]?.image}`}
                    alt='vehicle and Equipment'
                  />
                  <div>
                    <Typography
                      color='primary'
                      variant='h4'
                      className={classes.titleSecondary}
                      gutterBottom
                    >
                      {currentSlideData &&
                        currentSlideData.length !== 0 &&
                        currentSlideData[activeState][
                          isId ? 'title_id' : 'title_en'
                        ]}
                    </Typography>
                    <div className={classes.rowHeight}>
                      {currentSlideData &&
                        currentSlideData.length !== 0 &&
                        parse(
                          currentSlideData[activeState][
                            isId ? 'content_id' : 'content_en'
                          ]
                        )}
                    </div>
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() =>
                        history.push(
                          `/fasilitas/${fasilitasState[activeState].title_id}`
                        )
                      }
                    >
                      {isId ? 'Selengkapnya' : 'More'}
                    </Button>
                  </div>
                </div>
              </Fade>
            </div>
          ) : (
            <Typography align='center'>No Data</Typography>
          )}
        </div>
      )}
    </div>
  );
}

export default Fasilitas;
